import { useOperation } from '../../../types/Operation.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindBidByTradeStateOperation';

/**
 * Finds a Bid by its trade state address.
 *
 * ```ts
 * const nft = await metaplex
 *   .auctionHouse()
 *   .findBidByTradeState({ tradeStateAddress, auctionHouse };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findBidByTradeStateOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findBidByTradeStateOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      tradeStateAddress
    } = operation.input;
    const receiptAddress = metaplex.auctionHouse().pdas().bidReceipt({
      tradeState: tradeStateAddress,
      programs: scope.programs
    });
    return metaplex.auctionHouse().findBidByReceipt({
      receiptAddress,
      ...operation.input
    }, scope);
  }
};

export { findBidByTradeStateOperation, findBidByTradeStateOperationHandler };
//# sourceMappingURL=findBidByTradeState.mjs.map
